// Vue 国际化插件
import Vue from "vue";

// 翻译字典
const translations = {
  zh: {
    "nav.home": "首页",
    "nav.about": "企业简介",
    "nav.business": "业务布局",
    "nav.news": "新闻动态",
    "nav.contact": "联系我们",
    "footer.video": "官方视频号",
    "footer.wechat": "官方公众号",
    "footer.phone": "400-995-9120",
    "footer.address": "山东省青岛市李沧区万年泉路 237 号",
    "footer.aboutUs": "关于我们",
    "footer.businessScope": "业务范围",
    "footer.newsActivity": "新闻活动",
    "footer.founderMessage": "创始人寄语",
    "footer.companyIntro": "公司介绍",
    "footer.companyCulture": "企业文化",
    "footer.communityHealth": "社区医疗",
    "footer.medicalTech": "佳医科技",
    "footer.latestNews": "最新热点",
    "footer.realTimeActivity": "实时活动",
    "footer.recruitment": "招聘",
    "footer.cooperation": "合作",
    "footer.complaints": "投诉与建议",
    "home.onlineMedical": "线上医疗",
    "home.xjdd": "小佳到家",
    "home.xjdd.desc": "佳家康医疗集团旗下提供网约护理上门服务的线上平台。",
    "home.jhyy": "佳有好医",
    "home.jhyy.desc": "佳家康医疗集团旗下提供全方位医疗服务的互联网医院。",
    "home.xsxc": "线上商城",
    "home.xsxc.desc": "佳家康医疗集团旗下开展健康管理的线上平台。",
    "home.news": "新闻资讯",
    "home.tag.hot": "最新热点",
    "about.founderMessage": "创始人寄语",
    "about.companyIntro": "公司介绍",
    "about.companyCulture": "企业文化",
    "about.backToHome": "首页",
    "about.basicCommunityHealth": "集团发展历程",
    "about.standardization": "标准化建设",
    "about.standardization.desc":
      '佳家康医疗集团以标准化管理思维为指导，以标准化体系建设为主要抓手，以标准化实施为落脚点，为百万居民提供医疗预防、养生保健、健康指导等多位一体的健康管理服务，实现集团规模化快速发展，打造可复制的"佳家康发展模式"。',
    "about.tcmFamilyDoctor": "中医特色家庭医生",
    "about.tcmFamilyDoctor.desc":
      '佳家康医疗集团响应国家政策，独创"中医特色家庭医生模式"，将中医药融入家庭医生服务，为居民健康保驾护航。',
    "about.tianDao": "天道 - 企业之长久",
    "about.tianDao.desc":
      "尊天行道，把客户当作天，看作衣食父母，客户出现的地方皆为天道。佳家康以优质、高效、完善的服务满足客户的要求，所做的一切都是为了客户的全面满意。",
    "about.shiDao": "师道 - 企业之发展",
    "about.shiDao.desc":
      '以成果为导向，"成"既成就，"果"为结果。当下法为无上法，当下师为无上师，佳家康倡导向企业的优秀员工与有出色成果的同伴学习。',
    "about.xiaoDao": "孝道 - 企业之稳定",
    "about.xiaoDao.desc":
      "夫孝，德之本也。孝是佳家康人道德行为的基础，倡导热爱企业，爱护企业与同事，团结互助，使得职工对企业具有归属感；管理层做到关心下属、体恤下属，让员工体会到企业温暖。",
    "business.offlineMedical": "线下医疗",
    "business.onlineMedical": "线上医疗",
    "business.medicalTech": "佳医科技",
    "business.communityHealth": "1.社区医疗",
    "business.communityHealth.desc":
      "公共卫生服务及基本医疗服务。公共卫生服务包含卫生信息管理、健教、慢病预防控制、儿妇保、计划免疫等。基本医疗服务：一般常见病、多发病诊疗、护理和诊断明确的慢性病治疗；家庭医疗服务；转诊、康复医疗服务等。",
    "business.dental": "2.口腔医疗",
    "business.dental.desc":
      "佳家康口腔以种植、正畸、牙周、口内、口外、修复、儿牙为主，引进世界先进设备，拥有引领时代前沿的数字口腔治疗技术，通过 3D 数字化影像全方位检测、全息数字化方案设计、数字化分析治疗于一体的诊疗流程，让口腔治疗更精准、科学、快速，用专业技术、用心服务、诚信医疗、严苛院感，承载社会责任，赢得百姓口碑。",
    "business.tcm": "3.国医馆",
    "business.tcm.desc":
      "国医馆提供医诊疗、养生保健、健康管理学术研究及文化传播于一体的综合性中医服务，包含了中医科、中医理疗科、中药颗粒剂室、中药贴敷室等。依托传统中医理论，结合现代科技手段，中医特色疗法包含：针灸、推拿、刮痧、拔罐、督灸、脐灸、小针刀、穴位贴敷、耳穴压豆、艾灸、中药膏方、中药熏蒸等，适应症包含各类常见病、慢性病及亚健康状态调理。",
    "business.postpartum": "4.产康",
    "business.postpartum.desc":
      "佳家康产后康复中心成立于 2021 年 5 月，是针对女性产后时期系统化的康复指导和训练的综合恢复中心。中心引进目前国际上较为先进的普林格尔产后保健新技术，利用现代科技手段及时提供分娩后的延伸服务。从产后康复中心到产后安抚、心理疏导等服务，使产妇尽快将身体恢复到最佳状态。其中包括对产妇心理、营养、子宫复旧、盆底修复、形体恢复、产后疲劳、母乳喂养等进行全方位的健康恢复、指导、咨询。院内引进国际上先进设备，结合手法按摩，及时对产妇进行乳腺、生殖、腹肌、盆底肌、形体康复。",
    "news.industry": "行业热点",
    "news.company": "公司动态",
    "news.backToHome": "首页",
    "news.newsDetail": "新闻动态",
    "contact.recruitment": "招聘",
    "contact.cooperation": "合作",
    "contact.complaints": "投诉与建议",
    "contact.backToHome": "首页",
    "contact.contactUs": "联系我们",
    "common.goBack": "返回首页",
    "img.evn": "cn",
  },
  en: {
    "nav.home": "Home",
    "nav.about": "About Us",
    "nav.business": "Business Layout",
    "nav.news": "News & Activities",
    "nav.contact": "Contact Us",
    "footer.video": "Official Video Account",
    "footer.wechat": "Official WeChat Account",
    "footer.phone": "400-995-9120",
    "footer.address":
      "No. 237 Wannianquan Road, Licang District, Qingdao, Shandong",
    "footer.aboutUs": "About Us",
    "footer.businessScope": "Business Scope",
    "footer.newsActivity": "News & Activities",
    "footer.founderMessage": "Founder's Message",
    "footer.companyIntro": "Company Introduction",
    "footer.companyCulture": "Corporate Culture",
    "footer.communityHealth": "Community Health",
    "footer.medicalTech": "Jia Medical Tech",
    "footer.latestNews": "Latest News",
    "footer.realTimeActivity": "Real-time Activities",
    "footer.recruitment": "Recruitment",
    "footer.cooperation": "Cooperation",
    "footer.complaints": "Complaints & Suggestions",
    "home.onlineMedical": "Online Medical Services",
    "home.xjdd": "XiaoJia Home Care",
    "home.xjdd.desc":
      "An online platform under JiaJiaKang Medical Group providing online nursing services at home.",
    "home.jhyy": "JiaYou Good Doctor",
    "home.jhyy.desc":
      "An internet hospital under JiaJiaKang Medical Group providing comprehensive medical services.",
    "home.xsxc": "Online Store",
    "home.xsxc.desc":
      "An online platform under JiaJiaKang Medical Group for health management services.",
    "home.news": "News & Information",
    "home.tag.hot": "Hot News",
    "about.founderMessage": "Founder's Message",
    "about.companyIntro": "Company Introduction",
    "about.companyCulture": "Corporate Culture",
    "about.backToHome": "Home",
    "about.basicCommunityHealth": "Basic Community Health",
    "about.standardization": "Standardization",
    "about.standardization.desc":
      'JiaJiaKang Medical Group adopts standardized management thinking as guidance, focuses on standardization system construction, and implements standardized services to provide millions of residents with integrated health management services including medical prevention, health care, and health guidance. This achieves the group\'s rapid large-scale development and creates a replicable "JiaJiaKang Development Model".',
    "about.tcmFamilyDoctor": "TCM Family Doctor",
    "about.tcmFamilyDoctor.desc":
      'Responding to national policy, JiaJiaKang Medical Group has created a unique "TCM Family Doctor Model", integrating traditional Chinese medicine into family doctor services to protect residents\' health.',
    "about.tianDao": "Tian Dao - Longevity of Enterprise",
    "about.tianDao.desc":
      "Respect heaven and follow the path, treat customers as heaven, view them as providers of food and clothing. Wherever customers appear is the way of heaven. JiaJiaKang meets customer requirements with high-quality, efficient, and perfect services. Everything we do is for customer satisfaction.",
    "about.shiDao": "Shi Dao - Development of Enterprise",
    "about.shiDao.desc":
      'Results-oriented, "Cheng" means achievement, "Guo" means result. The current method is the supreme method, the current teacher is the supreme teacher. JiaJiaKang advocates learning from outstanding employees and partners with excellent results.',
    "about.xiaoDao": "Xiao Dao - Stability of Enterprise",
    "about.xiaoDao.desc":
      "Filial piety is the foundation of virtue. Filial piety is the foundation of the moral behavior of JiaJiaKang people. We advocate loving the enterprise, caring for colleagues, unity and mutual assistance, so that employees have a sense of belonging to the enterprise. Management cares for subordinates and shows consideration, allowing employees to feel the warmth of the enterprise.",
    "business.offlineMedical": "Offline Medical Services",
    "business.onlineMedical": "Online Medical Services",
    "business.medicalTech": "Jia Medical Tech",
    "business.communityHealth": "1. Community Health Services",
    "business.communityHealth.desc":
      "Public health services and basic medical services. Public health services include health information management, health education, chronic disease prevention and control, maternal and child health, planned immunization, etc. Basic medical services: diagnosis, treatment and nursing of general common diseases and frequently-occurring diseases, treatment of chronic diseases with clear diagnosis; home medical services; referral and rehabilitation medical services, etc.",
    "business.dental": "2. Dental Services",
    "business.dental.desc":
      "JiaJiaKang Dental focuses on implantology, orthodontics, periodontology, endodontics, oral surgery, prosthodontics, and pediatric dentistry. It introduces world-advanced equipment and owns cutting-edge digital dental treatment technology. Through a diagnosis and treatment process integrating 3D digital imaging comprehensive detection, holographic digital plan design, and digital analysis and treatment, it makes dental treatment more precise, scientific, and fast. With professional technology, attentive service, honest medical care, and strict infection control, it bears social responsibility and wins public reputation.",
    "business.tcm": "3. TCM Hall",
    "business.tcm.desc":
      "TCM Hall provides comprehensive traditional Chinese medicine services integrating medical diagnosis and treatment, health preservation, health management, academic research, and cultural dissemination. It includes TCM department, TCM physiotherapy department, Chinese medicine granule dispensing room, and Chinese medicine application room. Relying on traditional Chinese medicine theory and combining modern technology, TCM characteristic therapies include: acupuncture, massage, scraping, cupping, moxibustion, navel moxibustion, small needle knife, acupoint application, auricular point pressing, moxa, Chinese medicine paste, Chinese medicine fumigation, etc. Indications include various common diseases, chronic diseases, and sub-health conditioning.",
    "business.postpartum": "4. Postpartum Recovery",
    "business.postpartum.desc":
      "JiaJiaKang Postpartum Recovery Center was established in May 2021. It is a comprehensive recovery center for systematic rehabilitation guidance and training during the postpartum period for women. The center introduces relatively advanced Springer postpartum health care technology internationally and uses modern technological means to provide extended services after delivery in time. From postpartum recovery center to postpartum soothing and psychological counseling services, it helps parturient women restore their bodies to the best state as soon as possible. This includes comprehensive health recovery, guidance, and consultation on postpartum psychology, nutrition, uterine involution, pelvic floor repair, body shape recovery, postpartum fatigue, and breastfeeding. The hospital introduces internationally advanced equipment and combines manual massage to timely provide breast, reproductive, abdominal muscle, pelvic floor muscle, and body shape rehabilitation for parturient women.",
    "news.industry": "Industry Hotspots",
    "news.company": "Company News",
    "news.backToHome": "Home",
    "news.newsDetail": "News & Activities",
    "contact.recruitment": "Recruitment",
    "contact.cooperation": "Cooperation",
    "contact.complaints": "Complaints & Suggestions",
    "contact.backToHome": "Home",
    "contact.contactUs": "Contact Us",
    "common.goBack": "Back to Home",
    "img.evn": "cn",
  },
};

// 创建响应式的语言状态
const i18nPlugin = {
  install(Vue) {
    // 创建共享的响应式语言状态
    Vue.prototype.$i18n = Vue.observable({
      language: localStorage.getItem("lang") || "zh",
    });

    // 全局翻译方法
    Vue.prototype.$t = function (key) {
      const lang = this.$i18n ? this.$i18n.language : "zh";
      const langPack = translations[lang] || translations["zh"];
      return langPack[key] || key;
    };

    // 切换语言方法
    Vue.prototype.$setLocale = function (lang) {
      this.$i18n.language = lang;
      localStorage.setItem("lang", lang);
      // 强制重新渲染组件
      this.$forceUpdate();
    };
  },
};

export default i18nPlugin;
